import React from 'react'
import { RegisteredTrademarkIconWrapper } from './component.styles'

const RegisteredTrademarkIcon = () => {
  return <RegisteredTrademarkIconWrapper>&reg;</RegisteredTrademarkIconWrapper>
}

export default RegisteredTrademarkIcon
